export const ROOT = "/admin/lucky-draw-v2";
export const TRADITIONAL_RAFFLE_LIST = `${ROOT}/traditional-raffle`;
export const INSTANT_WIN_LIST = `${ROOT}/instant-win`;
export const LUCKY_DRAW_CREATE = `${ROOT}/traditional-raffle/new`;
export const INSTANT_WIN_CREATE = `${ROOT}/instant-win/new`;
export const LUCKY_DRAW_DETAIL = `${ROOT}/traditional-raffle/:luckyDrawUUID/`;
export const INSTANT_WIN_DETAIL = `${ROOT}/instant-win/:luckyDrawUUID/`;
export const LD_LIVE_DRAW = `${ROOT}/live-draw/:luckyDrawID`;
export const LUCKY_DRAW_PARTICIPANTS = `${ROOT}/:luckyDrawUUID/participants`;
export const VIEW_TRADITIONAL_RAFFLE_WINNERS = `${ROOT}/traditional-raffle/:uuid/view-winners`;
export const VIEW_INSTANT_WIN_WINNERS = `${ROOT}/instant-win/:uuid/view-winners`;
export const VIEW_TRADITIONAL_RAFFLE_CLAIM_LIST = `${ROOT}/traditional-raffle/:uuid/view-claim-list`;
export const VIEW_INSTANT_WIN_CLAIM_LIST = `${ROOT}/instant-win/:uuid/view-claim-list`;
